import { Link } from "react-router-dom";

function About() {
  return (
    <section id="about" className="about">
      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2
            style={{
              fontSize: "13px",
              letterSpacing: "1px",
              fontWeight: "700",
              margin: 0,
              color: "#4154f1",
              textTransform: "uppercase",
            }}
          >
            About Pratham
          </h2>
          <p>Discover the Vision Behind Pratham: Our Story</p>
          <div style={{ fontSize: "14px", fontWeight: "600", color: "gray" }}>
            Pratham is a pioneering computer vision platform by Assert AI,
            democratizing transformative technology for businesses of all sizes.
            Empowering users with its user-friendly interface for person count,
            vehicle count, and queue length analysis, providing actionable
            insights for enhanced operational efficiency and safety across
            various industries.
          </div>
        </header>
        <div className="row gx-0">
          <div
            className="col-lg-6 d-flex flex-column justify-content-center"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="content">
              <h2>No Code, No Limits</h2>
              <p>
                Pratham breaks the barriers of traditional analytics. Say
                goodbye to complex coding and cumbersome interfaces. With
                Pratham, no code is required, opening a world of possibilities
                for every user, regardless of their technical expertise.
              </p>
              <h2>No AI Expertise Needed</h2>
              <p>
                No need to be an AI expert to tap into the power of Vision AI.
                Pratham's intuitive interface empowers you to harness the
                capabilities of artificial intelligence without the learning
                curve. From beginners to seasoned professionals, Pratham is
                designed for everyone.
              </p>
              <div className="text-center text-lg-start">
                <Link
                  to="/auth/workspace"
                  className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center p-4"
                >
                  <span>Analyse your videos now</span>
                </Link>
              </div>
            </div>
          </div>

          <div
            className="col-lg-6 d-flex align-items-center"
            data-aos="zoom-out"
            data-aos-delay="200"
          >
            <img src="assets/img/aboutus.png" className="img-fluid" alt="" />
          </div>
        </div>
        <br />
        <br />
      </div>
      <div
        className="container"
        data-aos="fade-up"
        style={{ marginTop: "1rem" }}
      ></div>
      <div
        className="container"
        data-aos="fade-up"
        style={{ marginTop: "5rem" }}
      >
        <header className="section-header">
          <p>5 Steps to Intelligent Insights with Pratham</p>
        </header>
        <div className="row feture-tabs g-4" data-aos="fade-up">
          <div className="col-lg-6">
            <img
              src="assets/img/Infographic.png"
              width="80%"
              alt=""
              style={{ objectFit: "contain" }}
              height={600}
            />
          </div>
          <div className="col-lg-6">
            <h3 className="feature-boxh3">Upload Video</h3>
            <div className="tab-content">
              <div className="tab-pane fade show active">
                <p style={{ lineHeight: "28px" }}>
                  Effortlessly upload your video footage, whether it's from CCTV
                  surveillance or captured on your mobile device, to initiate
                  analysis.
                </p>
              </div>
            </div>
            <h3 className="feature-boxh3">Choose Use Cases</h3>
            <div className="tab-content">
              <div className="tab-pane fade show active">
                <p style={{ lineHeight: "28px" }}>
                  Select from a range of predefined use cases to specify the
                  type of insights you wish to extract from your video data.
                </p>
              </div>
            </div>
            <h3 className="feature-boxh3">Define Boundaries</h3>
            <div className="tab-content">
              <div className="tab-pane fade show active">
                <p style={{ lineHeight: "28px" }}>
                  Define precise boundaries by simply marking regions of
                  interest, streamlining the process for analytics
                  configuration.
                </p>
              </div>
            </div>
            <h3 className="feature-boxh3">No Code Video Analysis</h3>
            <div className="tab-content">
              <div className="tab-pane fade show active">
                <p style={{ lineHeight: "28px" }}>
                  Experience seamless video analysis without the need for
                  coding, as our AI technology handles the heavy lifting for
                  you.
                </p>
              </div>
            </div>
            <h3 className="feature-boxh3">Get Report</h3>
            <div className="tab-content">
              <div className="tab-pane fade show active">
                <p style={{ lineHeight: "28px" }}>
                  Receive comprehensive reports promptly; easily download them
                  or have them conveniently sent to your email for immediate
                  access and review.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
